import { ExternalTournamentWithEvents } from '@img-arena/consoles-api-streaming'
import { streamingRestApi } from '@/service/streamingApi'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'
import { UseImportEventsParamName } from '../useImportEventsStore'

const fetchTournamentWithEventsApi = async (
  args: FetchApiArgs<string, UseImportEventsParamName>
): Promise<
  FetchApiResponse<
    ExternalTournamentWithEvents['events'][number],
    { tournament: ExternalTournamentWithEvents | null }
  >
> => {
  const { signal, additionalParams: tournamentId } = args

  const tournament = await streamingRestApi.endpoints.importEvents.getExternalTournament(
    tournamentId,
    signal
  )

  return {
    content: tournament.events,
    totalElements: tournament.events.length,
    tournament
  }
}
export const useImportEventsTournamentStore = createBaseTableStore({
  storeName: 'Import Events Tournament',
  fetchApi: fetchTournamentWithEventsApi
})
